import React from "react";
import { Switch, Route } from "react-router-dom";
import { Home } from "../views/home/Home";

import { User } from '@authPortal/auth/user/view';
import { Role } from '@authPortal/auth/role/view';
import { Menu } from '@authPortal/auth/menu/view';

import { Organization } from "@authPortal/base/org/view";
import { BaseEntity } from "@authPortal/base/entity/view";
import { BaseDict } from "@authPortal/base/dict";
import { BaseStore } from "@authPortal/base/store/view";
import { BaseSetting } from "@authPortal/base/setting/view";
import { AppStatistic } from "@src/views/authPortal/appStatistic/view";
import { App } from "@authPortal/app/view";
import { Notice } from "@src/views/authPortal/notice/summary";
import { NoticeDetail } from "@src/views/authPortal/notice/detail";
import { Log } from "@src/views/authPortal/log/view";

import {RateSet} from "@src/views/authPortal/rate/set/view";
import {RateList} from "@src/views/authPortal/rate/list/view";



function FmsRoute() {
    return (
        <Switch>
            <Route exact={true} path={"/authPortal/"} component={Home} />
            <Route exact={true} path={"/authPortal/app"} component={App} />
            <Route exact={true} path={"/authPortal/auth/user"} component={User} />
            <Route exact={true} path={"/authPortal/auth/role"} component={Role} />
            <Route exact={true} path={"/authPortal/auth/menu"} component={Menu} />
            <Route exact={true} path={"/authPortal/notice"} component={Notice} />
            <Route exact={true} path={"/authPortal/notice/detail"} component={NoticeDetail} />
            <Route exact={true} path={"/authPortal/base/state"} component={BaseStore} />
            <Route exact={true} path={"/authPortal/base/org"} component={Organization} />
            <Route exact={true} path={"/authPortal/base/entity"} component={BaseEntity} />
            <Route exact={true} path={"/authPortal/base/dict"} component={BaseDict} />
            <Route exact={true} path={"/authPortal/base/setting"} component={BaseSetting} />
            <Route exact={true} path={"/authPortal/appStatistic"} component={AppStatistic} />
            <Route exact={true} path={"/authPortal/log"} component={Log} />
            <Route exact={true} path={"/authPortal/rate/set"} component={RateSet} />
            <Route exact={true} path={"/authPortal/rate/list"} component={RateList} />
        </Switch>
    )
}

export default FmsRoute;